<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/ZFlogo2.png" alt="logo图" />
    </div>
    <p class="address_tel_fax">
      <span>公司地址：四川省成都市青羊区光华北六路388号6栋3单元10层</span>
      <!-- <span>全国统一热线：028-6075878</span> -->
      <!-- <span>Fax：8888-88888888</span> -->
    </p>
    <p class="address_tel_fax">
      <span>全国统一热线：028-6075878</span>
    </p>
    <p class="email_wx">
      <span>邮箱：hushaojun@cdaifc.com</span>
      <!-- <span>公司微信号：ilyk_gg</span> -->
    </p>
    <p class="copy">Copyright &copy; 2024 成都中航智飞科技有限公司  蜀ICP备2022030692号-1 </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /* background: #474747; */
  overflow: hidden;
  text-align: center;
}
.logo {
  display: flex;
  padding: 80px 0 40px;
  justify-content: center;
}
.container-fluid {
  background-image: url("../assets/img/Vector2.png") !important;
  background-repeat:no-repeat;
  background-size:100% 100%;
  /* height: auto; */
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  #footer {
    background-color: none;
  }
  .container-fluid{
    /* background-image:url("../assets/img/Vector2.png");
    background-size:100% 100%;
    background-repeat:no-repeat; */
  }
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue